const MAP = {
  pending: ["En attente", "bg-[#FFF7D6] text-[#7A6100]"],
  approved: ["Approuvé", "bg-[#E8F2EF] text-[#1F7A63]"],
  rejected: ["Refusé", "bg-[#fbebeb] text-[#D93838]"],
  suspended: ["Suspendu", "bg-slate-200 text-slate-700"],
};

export const statusOf = (u) => u.status || (u.blocked ? "suspended" : "approved");

export default function StatusBadge({ user, status }) {
  const s = status || statusOf(user);
  const [label, cls] = MAP[s] || MAP.approved;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${cls}`} data-testid={`status-${s}`}>{label}</span>;
}
